export enum HomeCareRacesEnum {
    AmericanIndian = "0",
    AsianIndian = "1",
    AfricanAmerican = "2",
    Chinese = "3",
    Filipino = "4",
    White = "5",
    Japanese = "6",
    Korean = "7",
    NativeHawaiian = "8",
    OtherAsian = "9",
    PacificIslander = "10",
    Samoan = "11",
    Vietnamese = "12",
    Guamanian = "13"
}

export enum HomeCareEthnicityEnum {
    NotOfHispanic = "7",
    AnotherHispanic = "8",
    Cuban = "9",
    Mexican = "10",
    PuertoRican = "11"
}
